import { envConfig } from "../config/envConfigs";

export const loadDatalayer = (): void => {
  const script = document.createElement("script");
  script.src = envConfig.urls.datalayer;
  document.head.append(script);
};
